import { dteSystemApi } from "../../api";
import { DisableContingencyPayload, DteSystemStatusDTO, EnableContingencyPayload } from "../../types/dte/system/DteSystemTypes";

const DteSystemService = {

    /**
     * GET /api/dte/system/status
     */
    getStatus: async (): Promise<DteSystemStatusDTO> => {
        const response = await dteSystemApi.fetchCustom("/status");
        return response.data;
    },

    /**
     * POST /api/dte/system/contingency/enable?reason=...&user=...
     */
    enableContingency: async ({ reason, user }: EnableContingencyPayload): Promise<void> => {
        await dteSystemApi.addWithoutData(`/contingency/enable?reason=${encodeURIComponent(reason)}&user=${encodeURIComponent(user)}`);
    },

    /**
     * POST /api/dte/system/contingency/disable?user=...
     */
    disableContingency: async ({ user }: DisableContingencyPayload): Promise<void> => {
        await dteSystemApi.addWithoutData(`/contingency/disable?user=${encodeURIComponent(user)}`);
    }
};

export default DteSystemService;
